import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { SignIn, useAuth } from "@clerk/tanstack-react-start";
import { Center, Modal } from "@mantine/core";
import { useEffect, useState } from "react";
import LandingPage from "../features/landing/components/LandingPage";
import { canonicalUrl } from "../utils/site-url";

export const Route = createFileRoute("/")({
  // Only ?signin=true is meaningful (opens sign-in modal). Omit param for clean / URL.
  beforeLoad: ({ location }) => {
    const params = new URLSearchParams(location.searchStr);
    if (params.get("signin") === "false") {
      throw redirect({ to: "/", replace: true });
    }
  },
  validateSearch: (search: Record<string, unknown>): { signin?: true } => {
    const shouldSignIn = search.signin === true || search.signin === "true";
    return shouldSignIn ? { signin: true } : {};
  },
  head: () => {
    const url = canonicalUrl("/");
    return {
      meta: [{ property: "og:url", content: url }],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: IndexPage,
});

function IndexPage() {
  const { signin } = Route.useSearch();
  const { isSignedIn, isLoaded } = useAuth();
  const navigate = useNavigate();
  const [showSignIn, setShowSignIn] = useState(false);

  // Show sign-in modal if signin=true in URL
  useEffect(() => {
    if (signin && isLoaded && !isSignedIn) {
      setShowSignIn(true);
    }
  }, [signin, isLoaded, isSignedIn]);

  return (
    <>
      <LandingPage />
      <Modal
        opened={showSignIn}
        onClose={() => {
          setShowSignIn(false);
          navigate({ to: "/", replace: true });
        }}
        title=""
        centered
        size="auto"
        withCloseButton={false}
        padding={0}
        styles={{
          body: { padding: 0 },
          content: { background: "transparent" },
        }}
      >
        <Center>
          <SignIn routing="hash" forceRedirectUrl="/dashboard" signUpUrl="/sign-up" />
        </Center>
      </Modal>
    </>
  );
}
